import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getOfferLibraryTextBlocks = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}offer_library_text_blocks`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getOfferLibraryTextBlocks